import { render, staticRenderFns } from "./deviceType.vue?vue&type=template&id=85af37ce&scoped=true&"
import script from "./deviceType.vue?vue&type=script&lang=js&"
export * from "./deviceType.vue?vue&type=script&lang=js&"
import style0 from "./deviceType.vue?vue&type=style&index=0&id=85af37ce&scoped=true&lang=css&"
import style1 from "./deviceType.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85af37ce",
  null
  
)

export default component.exports